import React from 'react';

export default function Footer({ fixed }) {
  const footerStyle = {
    position: fixed ? "fixed" : "relative",
    bottom: 0,
    width: "100%",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
    color: "black"
  };

  return (
    <footer style={footerStyle}>
      <div
        className="text-center"
        style={{ backgroundColor: "#D9E724", borderColor: "#8b008b" }}
      >
        <a >
          © 2023 Copyright: Featfinder.it
        </a>
        <a>        -      </a>
        <a style={{ color: "black", cursor: "pointer" }}>
          Developed by: <a onClick={() => { window.location.replace("https://www.instagram.com/leo.tedo/?hl=it") }}><b>@leo.tedo</b></a>
        </a>
        <a>     -         </a>
        <a style={{ color: "black", cursor: "pointer" }}>
        Powered by: <a onClick={() => { window.location.replace("https://open.spotify.com/") }}><b>Spotify ©</b></a>
        </a>
      </div>
    </footer>
  );
}
